import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SignIn from './pages/signin';
import SignUp from './pages/registration';
import ForgotPassword from './pages/forgotPassword';
import MainPage from './pages';
import ActiveBids from './pages/activeBids'; 
import ArchivedBids from './pages/archivedBids';
import PrivateBids from './pages/privateBids';
import BidView from './pages/bidView';
import ApplyForBids from './pages/applyForBid';
import OTPPage from './pages/otpPage';
import MyBids from './pages/myBids';
import UserProfile from './pages/userProfile';
import VerifyOTPReset from './pages/verifyOtp';
import PaymentManagement from './pages/paymentRecieptsManager';
import Contacts from './pages/contacts';
import Vids from './pages/Videos';
import PrequalificationsCard from './pages/prequalificationCard';
import PrequalificationsPage from './pages/prequalificationPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/active-bids" element={<ActiveBids />} />
        <Route path="/application" element={<Vids/>} />
        <Route path="/archived-bids" element={<ArchivedBids />} />
        <Route path="/private-bids" element={<PrivateBids />} />
        <Route path="/bid-view" element={<BidView />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/otp" element={<OTPPage/>}/>
        <Route path="/applied-for-bid" element={<ApplyForBids/>}/>
        <Route path="/my-bids" element={<MyBids/>} />
        <Route path="/profile" element={<UserProfile/>} />
        <Route path="/contacts" element={<Contacts/>} />
        <Route path="/verify-otp" element={<VerifyOTPReset/>} />
        <Route path="/payment-management" element={<PaymentManagement/>} />
        <Route path="/my-prequalifications" element={<PrequalificationsPage/>} />
        <Route path="/prequalification" element={<PrequalificationsCard/>} />
      </Routes>
    </Router>
  );
}

export default App;
